import { render, staticRenderFns } from "./staff-detail.vue?vue&type=template&id=79d36092&scoped=true"
import script from "./staff-detail.vue?vue&type=script&lang=js"
export * from "./staff-detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79d36092",
  null
  
)

export default component.exports